import { useState } from "react";
import { IoIosArrowDown } from "react-icons/io";
import "./About.css";

const faqData = [
  {
    question: "How long does detailing take?",
    answer:
      "The amount of time depends on the service, vehicle size, and condition. A basic service may take a few hours, while heavily soiled interiors or paint correction may require most of the day or longer.",
  },
  {
    question: "Do I need to remove my belongings?",
    answer:
      "Yes to some extent. Please remove personal items if possible before your appointment. This allows us to clean the vehicle more thoroughly and not lose track of belongings.",
  },
  {
    question: "Can you remove every stain?",
    answer:
      "Many stains can be significantly improved or removed, but some permanent staining or damage may remain. We will always give you realistic expectations.",
  },
  {
    question: "Do you remove pet hair?",
    answer:
      "Yes. Pet-hair removal can be added when needed. Additional charges may apply depending on the amount and type of pet hair.",
  },
  {
    question: "Can paint correction remove deep scratches?",
    answer:
      "Paint correction can improve light scratches and swirl marks within the clear coat. Scratches that have gone through the clear coat or paint may require touch-up paint or body-shop repair.",
  },
  {
    question: "How often should I have my vehicle detailed?",
    answer:
      "Many everyday vehicles benefit from a professional detail two to four times per year. Maintenance frequency depends on how often the vehicle is driven, weather conditions, children, pets, and where it is parked.",
  },
  {
    question: "Do you provide exact prices online?",
    answer:
      "Starting prices can be listed online, but the final price may depend on the size and condition of the vehicle. Photos or an inspection can help us provide a more accurate quote.",
  },
  {
    question: "What types of vehicles do you service?",
    answer:
      "We detail most cars, trucks, SUVs, crossovers, and family vehicles. Contact us with any questions!",
  },
];

function About() {
  const [openIndex, setOpenIndex] = useState(null);

  return (
    <div className="faq-page">
      <section className="faq-header">
        <span className="faq-tag">PREMIUM DETAILING SERVICE</span>
        <h1>Frequently Asked Questions</h1>
        <p>
          Find answers to common questions about our detailing services,
          pricing, and process.
        </p>
      </section>

      <section className="faq-container">
        {faqData.map((item, index) => (
          <div
            className={`faq-item ${openIndex === index ? "active" : ""}`}
            key={index}
          >
            <button
              className="faq-question"
              onClick={() => setOpenIndex(openIndex === index ? null : index)}
            >
              <span>{item.question}</span>
              <IoIosArrowDown />
            </button>

            <div className="faq-answer">
              <p>{item.answer}</p>
            </div>
          </div>
        ))}
      </section>
    </div>
  );
}

export default About;
